import { Controller } from "@hotwired/stimulus"

// Opens a generated video in a large daisyUI <dialog> with full Video.js
// (@videojs/html) controls. The thumbnail tile stays chrome-free — the player
// skin only renders at full size, so its controls never collide with the tiny
// grid tiles. The video src is set lazily on first open, so nothing downloads
// until the admin actually clicks a tile.
export default class VideoLightboxController extends Controller {
  static targets = ["video", "dialog"]
  static values = { src: String }

  declare videoTarget: HTMLVideoElement
  declare dialogTarget: HTMLDialogElement
  declare srcValue: string

  private loaded = false

  open() {
    if (!this.loaded) {
      this.videoTarget.src = this.srcValue
      this.loaded = true
    }
    this.dialogTarget.showModal()
    // Triggered by a click, so audio autoplay is permitted.
    this.videoTarget.play().catch(() => {})
  }

  onClose() {
    this.videoTarget.pause()
  }
}
